var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup3231(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98.075,
    height: 99.999,
    viewBox: "0 0 98.075 99.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3231",
    "data-name": "Group 3231",
    transform: "translate(442.717 -150.585)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4701",
    "data-name": "Path 4701",
    d: "M-384.788,221.243q0-10.929,0-21.859c0-1.578.2-1.852,1.732-2.2a329.7,329.7,0,0,0,31.969-8.524,12.476,12.476,0,0,1,7.872-.115c10.542,3.005,21.168,5.719,31.767,8.524,1.758.465,2.005.723,2.005,2.561,0,14.052.22,28.109-.072,42.155-.244,11.769-5.679,20.89-15.74,27.068-4.456,2.736-9.1,5.164-13.659,7.731-1.6.9-3.187,1.827-4.808,2.69a6.9,6.9,0,0,1-6.957-.065c-6.261-3.5-12.6-6.874-18.72-10.6A31.015,31.015,0,0,1-384.317,246.5a44.594,44.594,0,0,1-.455-7.144c-.06-6.036-.02-12.074-.02-18.111Zm72.289.882h.009c0-7.076-.012-14.151.018-21.227,0-.728-.216-1.023-.919-1.188-11.112-2.6-22.145-5.505-33.04-8.914a2.229,2.229,0,0,0-1.288,0c-10.739,3.592-21.7,6.357-32.734,8.866-1.078.245-1.412.618-1.408,1.744.047,12.972.006,25.944.057,38.916a33.158,33.158,0,0,0,.575,6.4,28.246,28.246,0,0,0,13.656,19.469c5.863,3.488,11.893,6.693,17.805,10.1a4.81,4.81,0,0,0,5.264.014c5.8-3.33,11.7-6.472,17.438-9.9,9.277-5.538,14.179-13.828,14.527-24.62C-312.327,235.241-312.5,228.68-312.5,222.125Z",
    transform: "translate(-45.855 -29.6)",
    fill: "#6b344a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4702",
    "data-name": "Path 4702",
    d: "M-35.082,557.385a1.4,1.4,0,0,1-.792-.158,2.441,2.441,0,0,1-.984-1.281c-.057-.422.374-1.267.685-1.316a8.572,8.572,0,0,1,2.977.077c.277.056.56.915.546,1.4C-32.677,557.025-33.382,557.389-35.082,557.385Z",
    transform: "translate(-321.361 -319.855)",
    fill: "#6b344a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4703",
    "data-name": "Path 4703",
    d: "M9.684,553.617c1.412,0,2.029.364,2.151,1.263.139,1.021-.5,1.7-1.661,1.778-1.723.115-2.676-.44-2.666-1.551C7.517,554.124,8.261,553.615,9.684,553.617Z",
    transform: "translate(-356.495 -319.128)",
    fill: "#6b344a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4704",
    "data-name": "Path 4704",
    d: "M-11.63,575.159c0-.311-.127-.724.025-.912.382-.472.868-1.133,1.354-1.17a1.946,1.946,0,0,1,1.448.981,3.678,3.678,0,0,1,.144,1.922,1.413,1.413,0,0,1-1.641,1.345,1.427,1.427,0,0,1-1.35-1.544c-.01-.207,0-.415,0-.622Z",
    transform: "translate(-341.302 -334.535)",
    fill: "#6b344a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4705",
    "data-name": "Path 4705",
    d: "M-12.793,530.018a6.332,6.332,0,0,1,.882-1.781,1.317,1.317,0,0,1,1.948.122,3.138,3.138,0,0,1,.026,3.4,1.3,1.3,0,0,1-1.942.164A6.52,6.52,0,0,1-12.793,530.018Z",
    transform: "translate(-340.421 -298.733)",
    fill: "#6b344a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4706",
    "data-name": "Path 4706",
    d: "M-440.875,249.382a1.77,1.77,0,0,1-1.841-1.811,1.845,1.845,0,0,1,1.861-1.925,1.9,1.9,0,0,1,1.869,1.84A1.844,1.844,0,0,1-440.875,249.382Z",
    transform: "translate(0 -75.271)",
    fill: "#6b344a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4707",
    "data-name": "Path 4707",
    d: "M4.312,471.324a1.768,1.768,0,0,1,1.848-1.8,1.838,1.838,0,0,1,1.876,1.9,1.869,1.869,0,0,1-1.873,1.817A1.813,1.813,0,0,1,4.312,471.324Z",
    transform: "translate(-353.964 -252.541)",
    fill: "#6b344a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4708",
    "data-name": "Path 4708",
    d: "M-84.085,610.329a1.79,1.79,0,0,1-1.842-1.824,1.832,1.832,0,0,1,1.88-1.9,1.919,1.919,0,0,1,1.879,1.839A1.886,1.886,0,0,1-84.085,610.329Z",
    transform: "translate(-282.511 -361.081)",
    fill: "#6b344a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4709",
    "data-name": "Path 4709",
    d: "M-415.649,152.7c0-1.48.461-2.124,1.5-2.116,1.018.008,1.464.626,1.476,2.048.014,1.584-.419,2.26-1.461,2.28S-415.654,154.246-415.649,152.7Z",
    transform: "translate(-21.432 0)",
    fill: "#6b344a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4710",
    "data-name": "Path 4710",
    d: "M-439.075,179.118c-.489-.125-1.1-.112-1.434-.411a1.774,1.774,0,0,1-.574-1.4,2.007,2.007,0,0,1,1.11-1.156,3.97,3.97,0,0,1,1.735-.082,1.37,1.37,0,0,1,1.4,1.567,1.371,1.371,0,0,1-1.487,1.383c-.241.01-.483,0-.724,0Z",
    transform: "translate(-1.279 -20.133)",
    fill: "#6b344a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4711",
    "data-name": "Path 4711",
    d: "M-394.178,179.038c-.407-.053-.952.038-1.189-.19a2.283,2.283,0,0,1-.827-1.475,2.018,2.018,0,0,1,1.1-1.25,3.42,3.42,0,0,1,1.629-.089,1.428,1.428,0,0,1,1.526,1.573,1.473,1.473,0,0,1-1.61,1.388c-.207.008-.414,0-.621,0Z",
    transform: "translate(-36.835 -20.11)",
    fill: "#6b344a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4712",
    "data-name": "Path 4712",
    d: "M-415.657,197.513c0-1.565.54-2.242,1.688-2.114,1.009.112,1.355.789,1.292,2.522-.04,1.1-.577,1.772-1.441,1.807C-415.123,199.77-415.656,199-415.657,197.513Z",
    transform: "translate(-21.426 -35.473)",
    fill: "#6b344a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4713",
    "data-name": "Path 4713",
    d: "M-288.854,327.483c1.926-1.957,3.711-3.794,5.52-5.606q10.033-10.048,20.08-20.083c1.354-1.354,1.942-1.348,3.239.039,1.161,1.241,2.324,2.48,3.466,3.737.936,1.031.929,1.726-.035,2.69Q-272.1,323.786-287.625,339.3c-.935.934-1.678.952-2.6.037q-4.8-4.764-9.564-9.562a1.555,1.555,0,0,1-.02-2.594q2.005-2.04,4.046-4.045a1.562,1.562,0,0,1,2.594-.013C-291.763,324.51-290.39,325.927-288.854,327.483Zm-.165,8.62,29.4-29.387-2.042-2.216c-.349.332-.6.563-.846.806Q-274.9,317.7-287.289,330.089c-1.306,1.306-1.861,1.3-3.181-.014-1.3-1.294-2.6-2.589-3.832-3.822l-2.285,2.23Z",
    transform: "translate(-112.614 -118.931)",
    fill: "#6b344a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4714",
    "data-name": "Path 4714",
    d: "M-345.51,237.338v1.254q0,15.192,0,30.384c0,.243.008.486,0,.728-.048,1.154-.643,1.816-1.591,1.779-.9-.035-1.444-.691-1.445-1.8q-.01-10.041,0-20.083,0-6.5,0-13.007c0-1.46.3-1.814,1.7-2.137,9.269-2.139,18.484-4.477,27.514-7.5a3.235,3.235,0,0,1,1.8-.034c3.06.871,6.1,1.816,9.143,2.742,1.109.338,1.62,1.1,1.338,1.962-.294.9-1.071,1.249-2.2.919-2.82-.828-5.63-1.692-8.452-2.513a2.141,2.141,0,0,0-1.192-.06c-8.637,2.889-17.446,5.145-26.312,7.2A1.977,1.977,0,0,0-345.51,237.338Z",
    transform: "translate(-74.559 -60.36)",
    fill: "#6b344a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4715",
    "data-name": "Path 4715",
    d: "M-244.841,389.848a30.016,30.016,0,0,1-1.8,12,25.732,25.732,0,0,1-11.339,13.23c-4.505,2.587-9.038,5.126-13.525,7.743a6.386,6.386,0,0,1-6.959-.008c-4.6-2.69-9.254-5.3-13.885-7.946-.12-.069-.245-.13-.363-.2-.945-.577-1.219-1.371-.752-2.167a1.53,1.53,0,0,1,2.262-.443c3.075,1.739,6.138,3.5,9.206,5.25,1.744,1,3.506,1.964,5.226,3a3.175,3.175,0,0,0,3.515.034c4.8-2.767,9.7-5.37,14.41-8.283a21.846,21.846,0,0,0,10.737-17.14c.381-3.919.18-7.894.245-11.844.021-1.273.79-1.968,1.892-1.688.908.23,1.122.951,1.126,1.766C-244.834,385.164-244.841,387.175-244.841,389.848Z",
    transform: "translate(-118.005 -182.704)",
    fill: "#6b344a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3231);
export default __webpack_public_path__ + "static/media/Group 3231.5c4893ecc7e84f63092d1495d3d8a508.svg";
export { ForwardRef as ReactComponent };